import { parseEntityRef, stringifyEntityRef } from '@backstage/catalog-model';
import type { Entity } from '@backstage/catalog-model';

/**
 * Relation types that grant tab-config ownership rights. Mirrors
 * entity-tab-config-backend's OWNER_RELATION_TYPES: declarative ownership plus
 * GitHub repository admin teams synced by the github-repo-metadata module.
 */
const TAB_CONFIG_OWNER_RELATION_TYPES = new Set([
  'ownedBy',
  'githubRepoAdminBy',
]);

function normalizeRef(ref: string): string {
  try {
    return stringifyEntityRef(parseEntityRef(ref.trim())).toLowerCase();
  } catch {
    return ref.trim().toLowerCase();
  }
}

/**
 * Returns true when the caller may manage entity tab visibility — either via
 * declarative `ownedBy` ownership or a `githubRepoAdminBy` relation.
 */
export function isEntityTabConfigOwner(
  entity: Entity,
  ownershipEntityRefs: string[],
): boolean {
  const ownershipRefs = new Set(ownershipEntityRefs.map(normalizeRef));
  return (entity.relations ?? []).some(
    relation =>
      TAB_CONFIG_OWNER_RELATION_TYPES.has(relation.type) &&
      Boolean(relation.targetRef) &&
      ownershipRefs.has(normalizeRef(relation.targetRef)),
  );
}
